import React, { useEffect } from 'react'
import { getOS } from '@penguin/utils'

const os = getOS()

const index = () => {
  useEffect(() => {
    if (os === 'IOS') {
      window.location.href = 'QEUser://'
    } else if (os === 'Android') { 
      window.location.href = 'um.62abfb4505844627b5b68062://'
    }
  }, [])
  return <div></div>
}

export default index
